import * as React from "react";
import { computed } from "mobx";
import { FileResultInfo } from "../DocumentReader";
import { Urls } from "../Urls";

interface IDocumentPreviewIconProps {
	imageLoadComplete?: () => void;
	fileResult: FileResultInfo;
}

export class DocumentPreviewIcon extends React.Component<IDocumentPreviewIconProps, {}> {
	private onImageLoad = () => {
		if (this.props.imageLoadComplete != undefined) {
			this.props.imageLoadComplete();
		}
	}
	render() {

		if (this.props.fileResult.isCoverAvailable) {
			let guid = this.props.fileResult.fileLinkGuid;
			let src = "/files/" + guid + ".cover.jpg";
			return <i>
				<img src={src} onLoad={this.onImageLoad} />
			</i>
		}
		else {
			let src = "/images/general/No_Preview_Placeholder.svg";
			return <i>
				<img className="is--no-preview" src={src} onLoad={this.onImageLoad} />
			</i>
		}
	}
}
